import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { Consumivel } from '../types/Consumivel.type';

@Injectable({
  providedIn: 'root'
})
export class BaixaconsumiveisService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { }

  getConsumiveis(instancias: string, dataInicial: string | null, dataFinal: string | null){
      return this.httpClient.get<Consumivel[]> (`${this.configService.getApiUrlRoot()}/consumiveis/?instancias=${instancias}&dataInicial=${dataInicial}&dataFinal=${dataFinal}`)
  }

  exportarConsumiveis(corpo: any){
    return this.httpClient.post(`${this.configService.getApiUrlRoot()}/consumiveis/relatorios/exportar`, corpo, { responseType: 'blob'})
  }

  getTentativasHabilitado(){
      return this.httpClient.get(`${this.configService.getApiUrlRoot()}/consumiveis/tentativas-habilitado`)
  }

  reenviarConsumiveis(ids: number[]){
      return this.httpClient.post(`${this.configService.getApiUrlRoot()}/consumiveis/erp/reenviar`, ids)
  }

}